var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6"},[_c('div',{staticClass:"font-icon-detail",on:{"click":function($event){return _vm.$emit('toggle', {databaseColumnName: _vm.databaseColumnName, displayColumnName: _vm.displayColumnName})}}},[_c('h2',{class:{
        off: _vm.isClassOff,
        on: _vm.isClassOn
      }},[_vm._v("\n      "+_vm._s(_vm.displayStatus)+"\n    ")]),_c('p',[_vm._v(_vm._s(_vm.displayColumnName))])])])}
var staticRenderFns = []

export { render, staticRenderFns }